var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "a",
      {
        staticClass: "twitter-share-button",
        attrs: {
          href: "https://twitter.com/intent/tweet",
          "data-size": "small",
          "data-text": _vm.text,
          "data-url": _vm.url,
          "data-hashtags": "edbase",
          "data-related": "twitterapi,twitter",
        },
      },
      [_vm._v("\n    Tweet\n  ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }